import React, { useState, useEffect } from "react";
import { requestForToken, onMessageListener } from "./firebase";
import { toast } from "react-toastify";

const Notification = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const notify = () => toast(<ToastDisplay />);

  function ToastDisplay() {
    return (
      <div>
        <p>
          <b>{notification?.title}</b>
        </p>
        <p>{notification?.body}</p>
      </div>
    );
  }

  useEffect(() => {
    if (notification?.title) {
      notify();
    }
  }, [notification]);

  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await window.Notification.requestPermission();
        if (permission === "granted") {
          requestForToken();
        } else {
          console.log("Notification permission denied");
        }
      } catch (error) {
        console.error("Error requesting permission for notifications:", error);
      }
    };

    requestPermission();
  }, []);

  // requestForToken();

  onMessageListener()
    .then((payload) => {
      console.log("The payload for foreground notification", payload);
      setNotification({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        icon:
          payload?.notification?.icon ||
          "/images/default-notification-icon.jpeg",
      });
    })
    .catch((err) => console.log("failed: ", err));
};

export default Notification;
